import axios from 'axios'

export default {
  /**
   * Get all shipping methods (public - for delivery options page)
   */
  getAll() {
    return axios.get('/api/shipping-methods')
  },

  /**
   * Get all shipping methods (admin)
   */
  getAllAdmin() {
    return axios.get('/api/admin/shipping-methods')
  },

  /**
   * Get a single shipping method
   */
  getById(id) {
    return axios.get(`/api/admin/shipping-methods/${id}/show`)
  },

  /**
   * Create a new shipping method
   */
  create(data) {
    return axios.post('/api/admin/shipping-methods', data)
  },

  /**
   * Update a shipping method
   */
  update(id, data) {
    return axios.patch(`/api/admin/shipping-methods/${id}/update`, data)
  },

  /**
   * Delete a shipping method
   */
  delete(id) {
    return axios.delete(`/api/admin/shipping-methods/${id}/destroy`)
  },

  /**
   * Set a shipping method as default
   */
  setDefault(id) {
    return axios.post(`/api/admin/shipping-methods/${id}/set-default`)
  },

  /**
   * Bulk update services for a shipping method
   */
  updateServices(methodId, services) {
    return axios.patch(`/api/admin/shipping-methods/${methodId}/services`, { services })
  },

  /**
   * Add a new service to a shipping method
   */
  addService(methodId, data) {
    return axios.post(`/api/admin/shipping-methods/${methodId}/services`, data)
  },

  /**
   * Delete a service from a shipping method
   */
  deleteService(methodId, serviceId) {
    return axios.delete(`/api/admin/shipping-methods/${methodId}/services/${serviceId}`)
  }
}
